export default __webpack_public_path__ + "static/media/MZAS_LOGO.4d07352f.svg";